const parentLoginHome = () => import('@/views/parentLogin/index.vue')
const parentLoginIndex = () => import('@/views/parentLogin/pages/index.vue')
const loginModule = () => import('@/views/parentLogin/pages/loginModule.vue')

export default {
  path: '/',
  component: parentLoginHome,
  children: [
    {
      path: 'parentLogin',
      component: parentLoginIndex
    },
    {
      path: 'loginModule',
      component: loginModule
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/parentLogin/index.js